module.exports = __webpack_public_path__ + "img/6962ac4.svg";